
const OpenIcon = ({ color = "#667085" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M12.25 8.08333V11.5833C12.25 11.8928 12.1271 12.1895 11.9083 12.4083C11.6895 12.6271 11.3928 12.75 11.0833 12.75H2.91667C2.60725 12.75 2.3105 12.6271 2.09171 12.4083C1.87292 12.1895 1.75 11.8928 1.75 11.5833V3.41667C1.75 3.10725 1.87292 2.8105 2.09171 2.59171C2.3105 2.37292 2.60725 2.25 2.91667 2.25H6.41667" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.25 2.25L7 7.5" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.75 2.25H12.25V5.75" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default OpenIcon